import { useState, useEffect } from "react";

import './App.scss';

function HeaderEl({br, tx, hover=false}) {

    return (
      <div className={hover ? "header-el hov" : "header-el"}>
        <div className="el1">{br}</div>
        <div className="el2">{tx}</div>
      </div>
    )
  }
  
  function HeaderEl1({newGameFun=()=>{}}) {
    return (
      <div onClick={newGameFun} className="header-el1">nova igra</div>
    )
  }
  
  export function Header({welcomeSw=true, lev=1, brCards=12, moves=0, newGameFun=()=>{}}) {
    const [perfScore, setPerfScore] = useState("27-29");

    useEffect(()=>{
      switch (lev) {
        case 1:
          setPerfScore("8-10");
          break;
        case 2:
          setPerfScore("11-14");
          break;
        case 3:
          setPerfScore("14-17");
          break;
        case 4:
          setPerfScore("17-20");
          break;
        case 5:
          setPerfScore("22-25");
          break;
        case 6:
          setPerfScore("27-29");
          break;
      }
    }, [lev]);    
    return (
      <div className="header">
        {welcomeSw ? <p className="poruka">Odaberite zeljeni level:</p> :
        <>
          <HeaderEl br={lev} tx="Current level"/>
          <HeaderEl br={brCards} tx="Num. of cards"/>
          <HeaderEl br={moves} tx="Moves"/>
          <HeaderEl br={perfScore} tx="Perfect player" hover={true}/>
          <HeaderEl1 newGameFun={newGameFun}/>
        </>}
      </div>
    )
  }